import React, { useState, useMemo, useEffect, useRef } from "react";
import { formatTime } from "../../utils/FormatUtils";

const Countdown = ({ totalSeconds, onCountdownChange }) => {
  const initialRemaining = useMemo(() => {
    return Math.max(0, Math.floor((totalSeconds - Date.now()) / 1000));
  }, [totalSeconds]);

  const [remaining, setRemaining] = useState(initialRemaining);

  // Use ref to always have the latest callback without causing re-renders
  const onCountdownChangeRef = useRef(onCountdownChange);

  useEffect(() => {
    onCountdownChangeRef.current = onCountdownChange;
  }, [onCountdownChange]);

  const formattedTime = useMemo(() => {
    return formatTime(remaining);
  }, [remaining]);

  useEffect(() => {
    if (initialRemaining <= 0) {
      onCountdownChangeRef.current(true);
      return;
    }

    const timer = setInterval(() => {
      setRemaining((prev) => {
        const newRemaining = prev <= 1 ? 0 : prev - 1;
        if (newRemaining <= 0) {
          onCountdownChangeRef.current(true);
        }
        return newRemaining;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [initialRemaining]); // Remove onCountdownChange from dependencies

  return formattedTime;
};

export default React.memo(Countdown);
